/*
Dilip 01/09/2023 3075154998 Implemented System Notes Functionality
Sohel 01/10/2023 3075154998 System Notes API changes
suresh peddavoora 02/24/2023 3075154998 New UI changes
Akhila 06/06/2023 3075154998 added code and description in action
Akhila 06/15/2023 3075154998 added role access
Dilip-pds 10/19/2023 3075154998 fixed created by dropdown issue
*/
import React, {createRef, useState, useEffect} from 'react';
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {Button} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../../../../components/DialogBox';
import {resetSystemNotes, postSystemNotes} from '../../../../../redux/reducers/DataManager/index';
import AddUserDefinedNotes from '../../../../../components/AddUserDefinedNotes';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar/index';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import SearchNotesForm from '../../../../../components/SearchNotes/searchNotesForm';

export default function DmNotes({dmData, type, DataManagerAccess}) {
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        minWidth: '550px',
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
    {
      title: 'Created by',
      field: 'userId',
    },
    {
      title: 'Note Type',
      field: 'noteType',
    },
  ];

  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  let transcription = '';
  const tableRef = createRef();
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);

  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };

  const {isNotesLoading, addSystemNotesStatus, notesSuccessMsg, errorMsg} = useSelector(
    ({dataManagerGroup}) => dataManagerGroup,
  );
  useEffect(() => {
    if (addSystemNotesStatus === 200) {
      tableRef.current.onQueryChange();
      handleDialogClose();
      setTimeout(() => {
        dispatch(resetSystemNotes());
      }, 3000);
    }
  }, [addSystemNotesStatus]);

  useEffect(() => {
    if (submit) {
      tableRef?.current?.onQueryChange();
    }
  }, [submit, searchData]);

  const dispatchRecordFormatSystemNotes = (data) => {
    if (data) {
      dispatch(
        postSystemNotes(
          {
            code: dmData ? dmData?.dmCode : '',
            noteText: data,
            reportId:dmData?.dataManagerId ? dmData?.dataManagerId : 0,
          },
          type,
        ),
      );
    }
  };

  useEffect(() => {
    if (errorMsg || notesSuccessMsg) {
      setTimeout(() => {
        resetSystemNotes();
      }, 2500);
    }
  }, [errorMsg, notesSuccessMsg]);
  return (
    <>
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            charLimitMsg={charLimitMsg}
            isLoading={isNotesLoading}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            disableByRoleAccess={'enable'}
          />
        )}
      </DialogBox>
      <Grid className="system-notes-dialog">
        <SearchNotesForm
          setSearchData={setSearchData}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          dmData={dmData}
          type={type}
          moduleName={type === 'Export' ? 'exportmanager' : 'importmanager'}
        />
        <div className="custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url =
                  type === 'Export' ?
                    `data-manager/record/find/all/dmexportnotes` :
                    `data-manager/record/find/all/dmimportnotes`;
                const bodyObj = {
                  code: dmData?.dmCode,
                  limit: rows,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection,
                  search: '',
                  frameworkId:dmData?.dataManagerId ? dmData?.dataManagerId :0,
                  noteDate: searchData?.noteDate ?
                    moment(searchData?.noteDate).format('MM/DD/YYYY') :
                    '',
                  noteText: searchData?.noteText ? searchData?.noteText : '',
                  noteType: searchData?.noteType?.key ? searchData?.noteType?.key : '',
                  createdBy: searchData?.createdBy?.userLoginName ? searchData?.createdBy?.userLoginName : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!dmData?.dmCode) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObjects.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: true,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              pageSizeOptions: tablePageRows,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              {
                icon: () => (
                  <div>
                    <Button
                      variant="outlined"
                      className="search-btn"
                      disabled={!DataManagerAccess?.add}
                    >
                      <AddIcon /> Add
                    </Button>
                  </div>
                ),
                isFreeAction: true,
                disabled: !DataManagerAccess?.add,
                onClick: () => handleSelectedNotesOption(),
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    rowsPerPageOptions={tablePageRows}
                    labelRowsPerPage={'Rows per screen:'}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {notesSuccessMsg && <SuccessSnackbar successMsg={notesSuccessMsg} />}
    </>
  );
}
